import React, { Component } from 'react';
import { Button, Input, Select } from 'antd';
import API_URL from '../../../common/url';
import SearchSelect from '../../common/SearchSelect';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import $ from '../../../common/AjaxRequest';

const Option = Select.Option;

class Filter extends Component {
    state = {
        searchParams: {},
        hospitalOptions: [],
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    }

    search = () => {
        const { searchParams, params = {} } = this.state;
        this.props.search({
            ...searchParams,
            ...params,
        });
    }

    export = () => {
        this.props.export();
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        if (key == 'departmentId') {
            searchParams[key] = value;
            searchParams.positionIds = '';
            this.setState({
                searchParams,
                showPosition: false,
                positionOptions: [],
            }, () => {
                this.setState({ showPosition: true })
            });
        } else {
            searchParams[key] = value;
            this.setState({ searchParams });
        }
    }

    saveProvince = (checkedArea) => {
        const params = {};
        checkedArea.map(item => {
            params[`params[${item.props.title}]`] = item.key;
        });
        this.setState({ params });
    }

    hospitalSelectChange = value => {
        const { searchParams } = this.state;
        if (value) {
            searchParams.hospitalMainId = value.value;
            searchParams.hospitalMainName = value.text;
            searchParams.courtyardArea = undefined;
        } else {
            searchParams.hospitalMainId = '';
            searchParams.hospitalMainName = '';
        }
        this.setState({ searchParams },() => this.state.searchParams.hospitalMainId !== undefined && this.queryCourtyardAreaList());
    }

    timer = null;

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { searchParams: { hospitalMainId } } = this.state;
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: {    
                    hospitalMainId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    const needCourtyardArea = datas && datas[0].courtyardArea;
                    this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                }
            };
            $.sendRequest(options);
        }, 300);
    }

    parseHospitalData = (res, value) => {
        if ((res.data || res.datas)) {
            const sourceData = res.data.hospitalList.datas;
            const data = sourceData.map(item => ({
                text: `${item.hospitalName}`,
                value: item.hospitalId,
            }));
            this.setState({ hospitalOptions: data });
        } else {
            this.setState({ hospitalOptions: [] });
        }
    }

    addMember = () => {
        this.props.addMember();
    }

    render() {
        const { searchParams, hospitalOptions, CourtyardAreaList, needCourtyardArea } = this.state;
        const { employeeCode, userCompellation, workCity, courtyardArea, hospitalMainId, hospitalMainName } = searchParams;
        const { curRole } = sessionStorage;
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        return (
            <div className="filter-bar bar2">
                <div className="form-item">
                    <label className="ui-label">工号</label>
                    <Input value={employeeCode} placeholder="请输入工号" onChange={e => this.handleInputChange(e, 'employeeCode')} />
                </div>
                <div className="form-item">
                    <label className="ui-label">姓名</label>
                    <Input value={userCompellation} placeholder="请输入姓名" onChange={e => this.handleInputChange(e, 'userCompellation')} />
                </div>
                <div className="form-item">
                    <label className="ui-label">工作城市</label>
                    {/* <SelectProvince saveProvince={this.saveProvince} />       */}
                    <Input value={workCity} placeholder="请输入工作城市" onChange={e => this.handleInputChange(e, 'workCity')} />
                </div>
                <div className="form-item">
                    <label className="ui-label">状态</label>
                    <Select
                        placeholder="请选择"
                        onChange={value => this.handleSelectChange(value, 'status')}
                        style={{ width: 90 }}
                        allowClear={true}
                    >
                        <Option value="WORKING">在职</Option>
                        <Option value="LEFT">离职</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">负责医院</label>
                        <SearchRetrieve
                            keyword="hospitalName"
                            style={{ width: 200 }}
                            placeholder="输入医院名称检索"
                            value={hospitalMainName}
                            params={{ limit: 10, offset: 1 }}
                            url={API_URL.hospital.queryHospitalMainList}
                            config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                            onChange={value => this.hospitalSelectChange(value)}
                        />
                </div>
                <div className="form-item">
                    <label className="ui-label">负责院区</label>
                        <Select
                            mode='multiple'
                            filterOption={false}
                            onSearch={this.queryCourtyardAreaList}
                            style={{ width: 180 }}
                            placeholder="请选择"
                            disabled={ !needCourtyardArea || !hospitalMainId } //本无院区，禁止填入；本有院区，且医院信息已填，允许填入
                            value={courtyardArea}
                            onChange={value => this.handleSelectChange(value, 'courtyardArea')}
                            allowClear={true}
                        >
                            {CourtyardAreaOptions}
                        </Select>
                </div>
                {
                    (curRole == "CTA" || curRole == "BO" || curRole == "CRCC" || curRole == "CRCM") &&
                    <div className="form-item">
                        <label className="ui-label">是否汇报线下属</label>
                        <Select
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'isSubordinate')}
                            style={{ width: 80 }}
                            allowClear={true}
                        >
                            <Option value="1">是</Option>
                            <Option value="0">否</Option>
                        </Select>
                    </div>
                }
                <div className="form-item">
                    {
                        (curRole == "CTA" || curRole == "BO" || curRole == "CRCC" || curRole == "CRCM") &&
                        <Button type="primary" onClick={this.addMember}>添加成员</Button>
                    }
                    {
                        curRole != "CRC" &&
                        <Button type="primary" onClick={this.export}>导出</Button>
                    }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/hospital/ssu/Filter.js